import React, { useState } from 'react';

import { useMutation } from 'react-query';

import UseToast from 'hooks/use-toast';
import { courseSendFeedbackService, lectureSendFeedbackService } from 'services/core';

import ActionButton from '@core/components/actionbutton/ActionButton';

import EmptyStar from 'assets/icons/star-rate-empty.svg';
import FilledStar from 'assets/icons/star-rating.svg';
import ArrowrightIcon from 'assets/icons/arrow-right.svg';

import classes from './ShareCourseReview.module.scss';

const TRUSTPILOT_URL = 'https://www.trustpilot.com/review/pharmuni.com';
const GOOGLE_URL = 'https://www.google.com/maps/place/Pharmuni/@49.6079467,8.4589245,16.55z/data=!3m1!5s0x4797d39fe3f97be5:0xaa09ef242002d441!4m6!3m5!1s0x4797d366191934ed:0xfb1b85558e70d3af!8m2!3d49.6078798!4d8.4616476!16s%2Fg%2F11kptr4d7q?entry=ttu&g_ep=EgoyMDI2MDcwNi4wIKXMDSoASAFQAw%3D%3D';
const RATE_LIMIT = [1, 2, 3, 4, 5];

const ShareCourseReview = ({ contentType, contentID, onSuccess }) => {
	const { ToastContainer, toast } = UseToast();
	const [rate, setRate] = useState(0);
	const [reviewText, setReviewText] = useState('');

	const { mutate: sendFeedback, isLoading } = useMutation(
		contentType === 'lecture' ? lectureSendFeedbackService : courseSendFeedbackService,
		{
			onSuccess: () => {
				onSuccess && onSuccess();
			},
			onError: (error) => {
				let toasterror = 'Something went wrong!';
				typeof error.response.data.data === 'string' && (toasterror = error.response.data.data);
				typeof error.response.data.data === 'object' &&
					(toasterror =
						error.response.data.data?.messages && error.response.data.data?.messages[0]?.message);
				toast(toasterror || 'Something went wrong!', 'Alert');
			}
		}
	);

	const submitHandler = () => {
		sendFeedback({
			id: contentID,
			rate,
			comment: reviewText
		});
	};

	return (
		<div className={`${classes['share-course-review']} d-flex flex-column`}>
			<ToastContainer />
			<h3 className={classes['title']}>Share Review</h3>
			<h4 className={classes['question']}>How would you rate Pharmuni?</h4>
			<div className={classes['stars']}>
				{RATE_LIMIT.map((starRate) => (
					<button key={starRate} type="button" onClick={() => setRate(starRate)}>
						{starRate <= rate ? (
							<FilledStar data-testid="filled-star" />
						) : (
							<EmptyStar data-testid="empty-star" />
						)}
					</button>
				))}
			</div>
			<label htmlFor="share-review">Write your Review</label>
			<textarea
				id="share-review"
				name="share-review"
				value={reviewText}
				onChange={(e) => setReviewText(e.target.value)}
				placeholder="Tell us your feedback"
			/>
			<ActionButton kind="primary" disabled={!rate} loading={isLoading} onClick={submitHandler}>
				Submit Review
			</ActionButton>
			<div className={classes['external']}>
				<p>If you have 30 seconds, share an honest review on Google or Trustpilot.</p>
				<div className='d-flex justify-content-between w-100 gap-3'>
					<a href={TRUSTPILOT_URL} target="_blank" rel="noopener noreferrer">
						Trust Pilot <ArrowrightIcon />
					</a>
					<a href={GOOGLE_URL} target="_blank" rel="noopener noreferrer">
						Google Reviews <ArrowrightIcon />
					</a>
				</div>

			</div>
		</div>
	);
};

export default ShareCourseReview;
